/* eslint-disable react/destructuring-assignment */
import { Alert, Snackbar } from "@mui/material";

interface CustomSnackBarProps {
  open: boolean;
  handleOnClose: () => void;
  message: string;
}

export default function CustomSnackBar(props: CustomSnackBarProps) {
  return (
    <Snackbar
      open={props.open}
      autoHideDuration={3000}
      onClose={props.handleOnClose}
      // action={action}
    >
      <Alert onClose={props.handleOnClose} severity="error">
        {props.message}
      </Alert>
    </Snackbar>
  );
}
